export const checksums = {
  "pages": "1seD8HDho6",
  "articles": "D7gF9FRTv5",
  "categories": "QNOt47KSiD",
  "packages": "LeP1EZmWpX",
  "pageSlugs": "y00s8gl3bw",
  "blogSlugs": "xKm5qQdiRx"
}

export const tables = {
  "pages": "_content_pages",
  "articles": "_content_articles",
  "categories": "_content_categories",
  "packages": "_content_packages",
  "pageSlugs": "_content_pageSlugs",
  "blogSlugs": "_content_blogSlugs",
  "info": "_content_info"
}

export default {
  "pages": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "block": "json"
    }
  },
  "articles": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json",
      "block": "json"
    }
  },
  "categories": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "packages": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "pageSlugs": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "blogSlugs": {
    "fields": {
      "id": "string",
      "stem": "string",
      "extension": "string",
      "meta": "json"
    }
  },
  "info": {
    "fields": {}
  }
}